<template>
<div>
    <div class="card-container">
        <div class="image-header">
            <a v-if="isDownloadOnly" :href="this._document.filePath" :download="this._document.filePath">
                <button class="image-button" @click="countDownload">
                    <img :src="this._document.thumbnailPath" class="file-preview" loading="lazy">
                </button>
            </a>
            <button @click.prevent="openModal" class="image-button">
            <img :src="this._document.thumbnailPath" class="file-preview">
            </button>
            <b-modal has-modal-card :active.sync="isComponentModalActive" :width="960">
            <content-viewer :_document="_document" v-on:onModalClose="closeModal"></content-viewer>
            </b-modal>
        </div>
        
        <div class="document-info">
            <div class="document-title">
                <p>{{ _document.title }}</p>
            </div>

            <div class="document-type-container">
                <div class="document-type">{{ _document.singularProductType  }}</div>
                <div v-show="isDownloadOnly == true" class="download-only">*download only</div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import store from '../store.js'

import { mapState, mapMutations} from 'vuex'
import ContentViewer from './ContentViewer.vue'

export default {
    components:{
        'content-viewer': ContentViewer
    },

    name: 'documentGrid',

    props: {
        _document: Object,
    },

    data(){
        return{
            isComponentModalActive: false,
            downloadOnlyDataType: ["pptx", "avi", "docx", "doc", "xls", "xlsx", "mp4", "mp3", "wav", "flv", "mpeg", "mpv"],
        }
    },

    computed: {
        ...mapState([
            'userInfo'
        ]),


        isDownloadOnly: function(){
            if(this.downloadOnlyDataType.includes(this._document.fileExt) == true || this._document.documentType == "E-Tips with links"){
                return true
            } 
            else{
                return false
            }
        },


        locationURL: function(){
            if(window.location.hostname == 'localhost' ){
                return "http://localhost:8888/woodburn-unlimited/api/v1/"
            }
            else{
                return window.location.origin + "/api/v1/"
            }
        },


        isMobileDevice: function() {
            var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;
            return isMobile
        }
    },

    methods:{
        /**
         * OPENS MODAL WINDOW
         */
        openModal: function(){
            if(this.isMobileDevice ==true){
                this.$router.push({name: 'mobileContentViewer', params: { documentID: this._document.ID}});
            }
            else{
                this.isComponentModalActive = !this.isComponentModalActive
            }

            this.countView();
            
        },


        /**
         * CLOSES MODAL WINDOW
         */
        closeModal: function(){
            this.isComponentModalActive = false;
        },


        /**
        * ADDS A COUNT TO THE USER LOGGING IN
        */
        countView: async function(){
            var scriptParameters = `{
                "counterType" : "view",
                "userID": "${this.userInfo.userID}"
            }`;

            const result = await sharedAPI.runScript("User - Update Counters", scriptParameters)
        },


        /**
         * ADDS A COUNT TO THE NUMBER OF DOWNLOADS FOR THE USER
         */
        countDownload: async function(){
            var scriptParameters = `{
                "counterType" : "download",
                "userID": "${this.userInfo.userID}"
            }`;
            
            console.log("count download")
            const result = sharedAPI.runScript("User - Update Counters", scriptParameters)
        }
    }
}

</script>

<style scoped>
    .card-container{
        min-width: 225px;
        max-width: 225px;
        width: 100%;
        margin: 0px auto;
        position: relative;
        display: block;
        background-color: rgb(255, 255, 244);
        padding: 7px 0px 0px 0px;
    }
    .float-left{
        float: left;
    }
    .float-right{
        float: right;
    }
    .collapse-button{
        background-color: #d3d3d3;
        border: none;
        color: #696969;
        text-align: center;
        text-decoration: none;
        border-radius: 50%;
        padding: 1px;
        float: right;
        outline: none !important;
    }
    .column{
        margin: 0%;
        padding: 0%
    }
    .document-info{
        height: 95px;
        padding: 10px 20px 0 !important;
        background-color: #fff;
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        -webkit-box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.2);
        box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.2);
        position: relative;
        width: 100%;
        margin: 0px;
    }
    .document-title{
        font-weight: 500;
        color: #464646;
        height: 50px;
        line-height: 15px;
        display: flex;
        overflow: hidden;
    }
    .document-type-container{
        bottom: 16px;
        color: #878787;
        font-size: 14px;
        line-height: 1.375;
        left: 20px;
        position: absolute;
    }
    .document-type{
        display: inline-block;
        vertical-align: bottom;
        width: 100%;
    }
    .download-only{
        display: inline-block;
        vertical-align: bottom;
        font-size: .75rem;
        width: 100%;
    }
    .image-button{
        width: 100%;
        height: 185px;
        background-color: rgb(255, 255, 244);
        border-color: rgb(255, 255, 244);
    }
    .image-button{
        border: none;
        outline: none;
    }
    .image-header{
        height: 169px;
        margin: 10px auto 0px !important;
        width: 96%;
        background-color: rgb(255, 255, 244);
        overflow: hidden;
    }
    .package-documents{
        display: inline-block;
        margin: 5px;
        padding: 5px;

    }
    .subtitle{
        margin: 1px !important;
    }
    .file-preview{
        object-fit: cover;
        display: inline-block;
        vertical-align: middle;
        width: 100%;
        min-height: 100px;
    }

</style>